import { AGENT_HUB_ADMIN_BASE_PATH } from '@lumapps/agent-hub/constants';
import { AppId, createPageRoute, Route } from '@lumapps/router';

const agentHubServiceSettingsAdminRoute: Route = createPageRoute({
    slug: `${AGENT_HUB_ADMIN_BASE_PATH}/settings`,
    appId: AppId.backOffice,
});

export { agentHubServiceSettingsAdminRoute };
